package org.zq.astrock_ai.ui

import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

enum class WindowWidthSize {
    Compact,
    Medium,
    Expanded,
}

fun Dp.toWindowWidthSize(): WindowWidthSize = when {
    this < 600.dp -> WindowWidthSize.Compact
    this < 1024.dp -> WindowWidthSize.Medium
    else -> WindowWidthSize.Expanded
}

val WindowWidthSize.isCompact: Boolean get() = this == WindowWidthSize.Compact
val WindowWidthSize.isMediumOrCompact: Boolean get() = this != WindowWidthSize.Expanded
